import React from 'react'
import DefaultLeadsPage from '../../components/LeadsDataWithFilter/index'

function index() {
    return (
        <DefaultLeadsPage leadType="Dialshree" />
    )
}

export default index